
import { GameState } from '../GameContextTypes';

// Helper function to check if simulation is complete
export const checkSimulationComplete = (state: GameState): boolean => {
  if (!state.selectedRole || !state.gameStarted) return false;
  return state.careerLevel === 'Leader' || state.careerLevel === 'Expert';
};

// Helper function to check if player should level up
export const shouldLevelUp = (state: GameState): boolean => {
  return (
    (state.careerLevel === 'Junior' && state.yearsPassed >= 3 && state.experience >= 150) ||
    (state.careerLevel === 'Mid-Level' && state.yearsPassed >= 6 && state.experience >= 350) ||
    (state.careerLevel === 'Senior' && state.yearsPassed >= 10 && state.experience >= 700)
  );
};
